module.exports = __webpack_public_path__ + "img/login_bg.c88cc69c.jpg";